import request from '@/api/config.js'

export function getSupportMessages(orgId, params = {}) {
  return request({
    url: `support/org/${orgId}/messages`,
    method: 'get',
    params,
  })
}

export function sendSupportMessage(orgId, data) {
  return request({
    url: `support/org/${orgId}/messages`,
    method: 'post',
    data,
  })
}

export function sendSupportMessageWithAttachments(orgId, formData) {
  return request({
    url: `support/org/${orgId}/messages`,
    method: 'post',
    data: formData,
    // Общий таймаут 5 с не рассчитан на загрузку до 5 картинок по 10 МБ
    timeout: 60000,
  })
}
